import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { JobService } from '../services/sections/job/job.service';

@Injectable({
	providedIn: 'root'
})
export class CanCompleteJobResolver implements Resolve<Observable<boolean>> {

	constructor(
		private jobService: JobService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.jobService.canCompleteJob(activatedRouteSnapshot.paramMap.get('token'));
	}
}
